import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';

import useScroll from '../../../hooks/useScroll';
import { UserActionsMenu } from './UserActionsMenu';
import { fullName } from '../../../utils/textHelper';
import history from '../../../utils/history';
import { SUPPLIER } from '../../../constants/roles';
import { ArrowCaret } from '../../icons/analytics/ArrowCaret';
import { Roles } from '../../blocks/Roles';

import logo from '../../../images/cymbio-logo-only.svg';
import styles from './UserMenu.module.scss';

export function UserMenu() {
  const [sticky, setSticky] = useState(false);
  const { user, currentRole } = useSelector((state) => state.role);
  const roleId = useSelector((state) => (currentRole === SUPPLIER ? state.role.supplierId : state.role.retailerId));

  useScroll(
    ({ prevPos, currPos }) => {
      if (currPos.y > -56) {
        setSticky(false);
      } else if (currPos.y < prevPos.y) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    },
    null,
    { wait: 50 },
  );

  const goBack = () => history.push(currentRole === SUPPLIER ? `/suppliers/${roleId}` : `/retailers/${roleId}`);

  return (
    <div className={classNames(styles.wrapper_static, sticky ? styles.sticky : '')}>
      <header className={styles.header}>
        <div className={styles.leftSize}>
          <div className={styles.logo}>
            <Link to="/">
              <img alt="Cymbio Logo" src={logo} />
              <span>{fullName(user)}</span>
            </Link>
          </div>
        </div>

        <div className={styles.rightSize}>
          <button className={styles.backWrapper} onClick={goBack}>
            <span className={styles.caret}>
              <ArrowCaret />
            </span>
            <span>Back</span>
          </button>

          <Roles />

          <UserActionsMenu />
        </div>
      </header>
    </div>
  );
}
